module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"candidateRemoved":"Кандидат удалён","candidateRemovedTip":"Кто-то удалил этого кандидата, либо вы удалили его в другом окне браузера.","toCandidateList":"К списку кандидатов","vacancy":"Вакансия","candidate":"Кандидат","evaluationCandidate":"Оценка кандидата","evaluationCandidateAi":"Оценка кандидата от ИИ","summaryInterview":"Краткое содержание интервью"}}')
  delete Component.options._Ctor
}
